<template>
    <div class="main-block main-shadow">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'main-block'
}
</script>

<style lang="scss" scoped> 
.main-block {
    height: 95vh; 
    background-color: #fff;
    padding: 20px;
    box-shadow: rgba(0, 0, 0, 0.1) 0 0 10px;
    overflow: hidden;
}
</style>